module.exports = __webpack_public_path__ + "img/short02.bc91632e.jpg";